<template>
    <div>
        <loading v-if="loading"></loading>
        <div
            v-else
            class="select"
            :class="{ 'is-danger' : (errors.has('channelShippingMethodId') && isRequired) }"
        >
            <select
                v-model.number="localValue"
                name="channelShippingMethodId"
                v-validate="{ required : isRequired, numeric : true, min_value : 1 }"
            >
                <option
                    v-for="method in methods"
                    :key="'method|' + method.id"
                    :value="method.id"
                >
                    {{method.name}}
                </option>
            </select>
            <div
                v-if="!methods.length"
                class="message is-warning"
            >
                <div class="message-body">
                    No Channel Shipping Methods mapped. Please contact {{this.$store.state.dealer_portal.settings.brand_name}} to proceed.
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ChannelApi from '../../../api/Channels';
export default {
    name : 'ChannelShippingMethodSelector',
    inject : ['$validator'],
    props : {
        channelId : {
            type : Number,
            required : true
        },
        isRequired : {
            type : Boolean,
            required : false,
            default : false
        },
        value : {
            type : Number,
            required : false,
            default : 0
        }
    },
    data(){
        return {
            methods : null,
            loading : false
        }
    },
    computed : {
        localValue : {
            get(){
                return this.value;
            },
            set(value){
                this.$emit('input', value);
                this.$emit('change', value);
            }
        }
    },
    beforeMount(){
        this.localValue = this.value;
        this.getChannelShippingMethods();
    },
    methods : {
        getChannelShippingMethods(){
            this.loading = true;
            ChannelApi.getShippingMethods(this.channelId).then((response) => {
                let methods = [ ];
                methods.push({
                    id : 0,
                    name : 'Select Shipping Method'
                });
                this.methods = methods.concat(response.data);
            }).finally(() => {
                this.loading = false;
            })
        }
    },
}
</script>
